import { CountryItem, IndustryItem, SublistItem } from '@type/common';

export const getItemFromSubList = (
  id: number,
  list: CountryItem[] | IndustryItem[],
  subListName: string
): SublistItem => {
  let returnItem: SublistItem = null;

  list.forEach((item) => {
    item[subListName].forEach((subListItem: SublistItem) => {
      if (parseInt(subListItem.Id) === id) returnItem = subListItem;
    });
  });

  return returnItem;
};

export const getNameFromSubList = (
  id: number,
  list: CountryItem[] | IndustryItem[],
  subListName: string
): string => {
  return getItemFromSubList(id, list, subListName)?.Name || '';
};

export const getNameFromList = (id: number, list: SublistItem[] | IndustryItem[]): string => {
  return getItemFromList(id, list)?.Name || '';
};

export const getItemFromList = (
  id: number,
  list: CountryItem[] | IndustryItem[] | SublistItem[]
): IndustryItem | SublistItem => {
  let returnItem: IndustryItem | SublistItem = null;

  list.forEach((item) => {
    if (parseInt(item.Id) === id) returnItem = item;
  });
  return returnItem;
};
